import styled from '@emotion/styled';
import BaseFab from '@material-ui/core/Fab';
import theme from '../../themes/default';

const getStyles = ({ type }) => {
  const tokensForType = theme.fab[type];
  const { backgroundColor, width, height, color } = tokensForType;
  return `
  background-color: ${backgroundColor};
  width: ${width};
  height: ${height};
  color: ${color};
  `;
};

const whiteOverlay = (opacity) => `
  content: '';  
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  border-radius: ${theme.borderRadius.extraLarge};;
  background-color: rgba(255,255,255,${opacity});
  height: 100%;
`;

const blackOverlay = (opacity) => `
  content: '';  
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  border-radius: ${theme.borderRadius.extraLarge};;
  background-color: rgba(0,0,0,${opacity});
  height: 100%;
`;

const getOverlay = ({ type }, opacity) =>
  type === 'primary' ? whiteOverlay(opacity) : blackOverlay(opacity);

const StyledBaseFab = styled(BaseFab)`
  ${(props) => getStyles(props)}
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 3px 5px rgba(0, 0, 0, 0.2);
  :hover {
    background-color: ${(props) => theme.fab[props.type].backgroundColor};
    ::after {
      ${(props) => getOverlay(props, theme.opacity.alpha4)}
    }
  }
  :focus {
    background-color: ${(props) => theme.fab[props.type].backgroundColor};
    ::after {
      ${(props) => getOverlay(props, theme.opacity.alpha12)}
    box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14),
      0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
  }
  :active {
    background-color: ${(props) => theme.fab[props.type].backgroundColor};
    ::after {
      ${(props) => getOverlay(props, theme.opacity.alpha100)}
    }
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14),
      0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
  }
`;

export default StyledBaseFab;
